<template>
  <div>
    <ArticleDesktop
      v-if="isDesktopView"
      :id="id"
    />
    <ArticleMobile
      v-if="isMobileView"
      :id="id"
    />
  </div>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'
import sharedMethods from '@/methods/sharedMethods'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import ArticleDesktop from '@/components/Views/Home/ArticleDesktop'
import ArticleMobile from '@/components/Views/Home/ArticleMobile'
import articleComputed from '@/methods/articleComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ArticleContainer',

  metaInfo () {
    return this.getMetaTags()
  },

  props: {
    id: {
      type: String,
      default: null,
    }
  },

  components: {
    ArticleMobile,
    ArticleDesktop,
  },

  watch: {
    selectedArticle () {
      this.setArticleMeta()
    }
  },

  created () {
    this.setContentAreaWidth()
    this.setArticleMeta()
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,
  },

  methods: {
    ...sharedMethods,

    setArticleMeta () {
      const article = this.selectedArticle
      console.log('set-meta', this.selectedArticle, this.lang)
      this.selectedObject = {} // To enable all dates in date picker
      this.metaUrl = this.defaultMetaUrl
      this.metaImage = this.defaultMetaImage

      this.metaTitle = article['metaTitle_' + this.lang] || this.metaSiteName
      this.metaDescription = article['metaDescription_' + this.lang] || this.defaultMetaDescription
      this.metaKeywords = article['metaKeywords_' + this.lang]
    },
  },
}
</script>
